import BaseScreen from './BaseScreen'
export default BaseScreen
